<div class="pagina-resultado-filtro">
  <div class="header-topo">
    <div
      class="modulo-dropdown-wrapper"
      (click)="dropdownAberto = !dropdownAberto"
    >
      <div class="modulo-select">
        <p>{{ moduloSelecionado?.label }}</p>

        <span class="seta-dropdown" [class.aberto]="dropdownAberto"></span>
      </div>
      <ul class="modulo-opcoes" *ngIf="dropdownAberto">
        <li
          *ngFor="let modulo of modulos"
          (click)="onModuloDropdownSelect(modulo)"
          [class.ativo]="modulo.value === moduloSelecionado?.value"
        >
          {{ modulo.label }}
        </li>
      </ul>
    </div>

    <div class="filtros-acao">
      <div class="filtro">
        <select
          id="tarefa"
          [(ngModel)]="selectedOptionAcao"
          [disabled]="!(podeEditarAcao || temAcessoModulo)"
        >
          <option value="0">Selecionar tarefa</option>
          <option *ngFor="let t of listTasks" [value]="t.id">
            {{ t.description }}
          </option>
        </select>
      </div>

      <div class="filtro">
        <input
          id="data"
          type="date"
          [min]="todayString"
          [(ngModel)]="selectedDate"
          [disabled]="!(podeEditarAcao || temAcessoModulo)"
        />
      </div>

      <div class="filtro">
        <select
          id="responsavel"
          [(ngModel)]="selectedOptionResponsavel"
          [disabled]="!(podeEditarAcao || temAcessoModulo)"
        >
          <option value="0">Selecionar responsável</option>
          <option *ngFor="let r of listResponsible" [value]="r.id">
            {{ r.name }}
          </option>
        </select>
      </div>

      <button
        class="btn-atualizar"
        (click)="updateWork()"
        type="button"
        [disabled]="!podeEditarAcao"
      >
        ATUALIZAR
      </button>
    </div>
  </div>

  <div class="pagina-resultado-busca">
    <div class="coluna-filtros">
      <div class="total-obras-resultado">
        <h2 class="total-obras-resultado-p">
          <div>
            <img
              src="{{ BASE_IMG_URL }}assets/buscas/company.svg"
              alt=""
            />
          </div>

          Total de obras: <span>{{ recordCount }}</span>
        </h2>
      </div>

      <ng-container [ngSwitch]="moduloSelecionado?.value">
        <app-filtro-busca-imobiliario
          *ngSwitchCase="234"
          (resultadoChange)="onResultadoImobiliarioChange($event)"
          (loadingChange)="loadingWorks = $event"
          [temAcessoModulo]="temAcessoModulo"
        ></app-filtro-busca-imobiliario>
        <app-filtro-busca-infra-edificacoes-industrial
          *ngIf="[5, 6, 7].includes(moduloSelecionado?.value)"
          [idModuloSelecionado]="moduloSelecionado?.value"
          (resultadoChange)="onResultadoIndustrialChange($event)"
          (loadingChange)="loadingWorks = $event"
          [temAcessoModulo]="temAcessoModulo"
        ></app-filtro-busca-infra-edificacoes-industrial>
      </ng-container>
    </div>

    <div class="coluna-resultados">
      <app-listagem-obras
        [data]="tabelaDados"
        [columns]="tabelaColunas"
        [loading]="loadingWorks"
        [mostrarApenasItensPagina]="true"
        [isResultadoFiltro]="true"
        [page]="tabelaPage"
        [pageSize]="tabelaPageSize"
        [totalItems]="tabelaTotalItems"
        [temAcessoModulo]="temAcessoModulo"
        [podeEditarAcao]="podeEditarAcao"
        (pageChange)="onTabelaPageChange($event)"
        (pageSizeChange)="onTabelaPageSizeChange($event)"
        (abrirFichaObra)="abrirFichaObra($event.id)"
        (sortChange)="onTabelaSortChange($event)"
        (selectionChange)="onTabelaSelectionChange($event)"
        (downloadPdf)="downloadPDFFicha()"
        (imprimir)="impressaoFicha()"
        (excel)="exportExcel()"
        (abrirEmpresa)="onAbrirEmpresa($event)"
      ></app-listagem-obras>
      <ng-container *ngIf="!temAcessoModulo && !loadingWorks && modulosDisponiveisCarregados">
        <app-footer-listagem-busca
          [moduloIDs]="moduloIDs"
          [idSelecionado]="moduloSelecionado?.value"
        ></app-footer-listagem-busca>
      </ng-container>
    </div>
  </div>
</div>

<app-common-loader *ngIf="loadingWorks"></app-common-loader>

@if (processandoAcao) {
  <app-modal-aguardando-download [mensagem]="mensagemProcessando"></app-modal-aguardando-download>
}

@if (modalMensagem) {
  <app-modal-mensagem
    [tipo]="modalMensagem.tipo"
    [titulo]="modalMensagem.titulo"
    [mensagem]="modalMensagem.mensagem"
    (confirmar)="onFecharModalMensagem()"
  ></app-modal-mensagem>
}

@if (exibirModalSaida) {
  <app-modal-intencao-saida></app-modal-intencao-saida>
}
